module.exports = __webpack_public_path__ + "img/IMG_8902.a061ac17.jpg";